<template>
    <div class="loader">
        <div
            :class="`spinner text-${variant}`"
            role="status">
            <i class="i-load spinning" />
            <span class="sr-only">Loading...</span>
        </div>
        <p
            v-if="status"
            class="loading-status text-primary">
            {{ status }} ...
        </p>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    props: {
        status: {
            type: String,
            default: null
        },
        variant: {
            type: String,
            default: 'primary'
        }
    },
    methods: {}
};
</script>
<style lang="scss" scoped>
.loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 5rem;

    &.overlayer {
        display: flex;
        position: absolute;
        z-index: 100;
        top: 0;
        left: 0;
        flex-direction: column;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9);
    }

    .spinner {
        color: var(--primary);
    }

    &.page-overlay {
        display: flex;
        position: fixed;
        z-index: 100;
        top: 0;
        left: 0;
        flex-direction: column;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        pointer-events: auto;
    }

    &.semi-transparent {
        background-color: rgba(255, 255, 255, 0.5) !important;
    }

    .loading-status {
        display: block;
        margin-top: 1.5rem;
        padding: 0 1rem;
    }
}
</style>
